'use client';

import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '@/services/ApplicationInsights';

export function AppInsightsProvider({ children }: { children: React.ReactNode }) {
  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      {children}
    </AppInsightsContext.Provider>
  );
}
